import collection from '../../../api/collections/LeadDetails'
import asyncMiddleware from '../../../utils/action-handler'

export default {
  namespaced: true,
  state: {
    list: [],
    item: {},
    pagination: {}
  },
  mutations: {
    SET_LEAD_DETAIL(state, data) {
      state.list = data
    },
    SET_LEAD_DETAIL_ITEM(state, data) {
      state.item = data
    },
    RESET_LEAD_DETAIL(state, data) {
      state.item = {}
    },
    SET_LEAD_DETAIL_TABLE_PAGINATION(state, data) {
      state.pagination = data
    }
  },
  actions: {
    async GET_LEAD_DETAIL({ commit, dispatch }, payload) {
      return await asyncMiddleware(async function() {
        const { data } = await collection.get(payload)
        commit('SET_LEAD_DETAIL', data.data)
        return data
      }, commit, dispatch, 'GET_LEAD_DETAIL', true)
    },
    async CREATE_LEAD_DETAIL({ commit, dispatch }, payload) {
      const data = await asyncMiddleware(async function() {
        const { data } = await collection.create(payload)
        return data
      }, commit, dispatch, 'CREATE_LEAD_DETAIL', true)
      return data
    },
  }
}
